import './reviews.scss';

export default () => {
    function onGoogleReviewsLoaded(callback) {
        const checkWidget = setInterval(() => {
            if (document.querySelector(".ti-widget-container")) {
                clearInterval(checkWidget);
                callback();
            }
        }, 100);

        setTimeout(() => clearInterval(checkWidget), 10000); // Timeout after 10s
    }

    onGoogleReviewsLoaded(() => {
        const toRating = document.querySelector('.js-to-rating');
        const ratingText = document.querySelector('.ti-rating-text');
        toRating.append( ratingText);
    });
};
